import { useMediaQuery } from '@abyss/web/hooks/useMediaQuery';
import { Drawer } from '@abyss/web/ui/Drawer';
import { Flex } from '@abyss/web/ui/Flex';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import { Popover } from '@abyss/web/ui/Popover';
import { Text } from '@abyss/web/ui/Text';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { phoneOnly } from '../ConstantsStyles';
import { distancePopover, drawerStyle } from './DistanceInfoIcon.styled';

export const DistanceInfoIcon = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  const mobileScreen = useMediaQuery(phoneOnly);
  const popOverContent: string = t('DISTANCE_POPOVER_CONTENT');
  const title: string = t('CONTENT_FILTERS.DISTANCE');
  const content = () => (
    <Flex
      alignItems="center"
      css={{ paddingTop: '12px' }}
      data-auto-testid="distance-info-icon-button"
      data-testid="distance-info-icon-button"
      onClick={() => setIsOpen(true)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setIsOpen(true);
        }
      }}
    >
      <IconSymbol
        aria-hidden="true"
        focusable="false"
        icon="info"
        size={16}
        variant="outlined"
      />
      <Text
        css={{
          lineHeight: '18px',
          fontSize: '14px',
          color: '$interactive1 !important',
          paddingLeft: '8px',
        }}
      >
        {t('CONTENT_FILTERS.ALL_FILTERS_DRAWER.DISTANCE_INFO_ICON')}
      </Text>
    </Flex>
  );

  return (
    <React.Fragment>
      {!mobileScreen ? (
        <Popover
          content={popOverContent}
          css={distancePopover}
          data-testid="distance-info-icon-popover"
          onOpenChange={() => {
            setIsOpen(!isOpen);
          }}
          open={isOpen}
          title={title}
          width={220}
        >
          {content()}
        </Popover>
      ) : (
        <React.Fragment>
          {content()}
          <Drawer
            css={drawerStyle}
            data-auto-testid="distance-info-icon-popover"
            data-testid="distance-info-icon-popover"
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            position="bottom"
            title={title}
            titleAlign="left"
          >
            <Drawer.Section>{popOverContent}</Drawer.Section>
          </Drawer>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
